import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { map, startWith, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-changing-shipper-dialog',
  templateUrl: './changing-shipper-dialog.component.html',
  styleUrls: ['./changing-shipper-dialog.component.scss']
})
export class ChangingShipperDialogComponent implements OnInit {
  newShipperInfoForm: FormGroup;
  filteredShipperList: Observable<any[]> = of([]);
  addresses: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<ChangingShipperDialogComponent>,
    private fb: FormBuilder,
    private http: HttpClient
  ) {
    this.newShipperInfoForm = this.fb.group({
      new_shipper_control: [''],
      shipper_contact_uuid: [''],
      shipper_address_uuid: [''],
      shipper_name: [''],
      shipper_locality: [''],
      shipper_region: ['']
    });
  }

  ngOnInit(): void {
    this.setupShipperAutocomplete();
  }

  setupShipperAutocomplete() {
    this.filteredShipperList = this.newShipperInfoForm.get('new_shipper_control')!.valueChanges.pipe(
      startWith(''),
      switchMap(value => {
        if (typeof value === 'string' && value.length >= 3) {
          return this.getShipperList(value);
        } else {
          return of([]);
        }
      })
    );
  }

  getShipperList(query: string): Observable<any[]> {
    const url = `/api/work_orders/contact_autofill.php?type=shipper_contact_list&search=${query}`;
    return this.http.get<any[]>(url).pipe(
      map(response => response || [])
    );
  }

  displayFn(shipper: any): string {
    return shipper && shipper.label ? shipper.label : '';
  }

  onShipperSelected(selectedShipper: any) {
    this.newShipperInfoForm.get('shipper_contact_uuid')!.setValue(selectedShipper.value);
    this.newShipperInfoForm.get('shipper_name')!.setValue(selectedShipper.label.split(' - ')[0]);
    console.log(selectedShipper);

    // Fetch full shipper details
    this.http.get(`/api/work_orders/contact_autofill.php?type=contact_data&uuid=${selectedShipper.value}`).subscribe((details: any) => {
      const data = details[0];
      if (data && data.addresses) {
        this.addresses = data.addresses;
        if (this.addresses.length > 0) {
          const defaultUuid = this.addresses[0].contact_address_uuid;
          this.newShipperInfoForm.get('shipper_address_uuid')!.setValue(defaultUuid);
          this.onAddressSelected(defaultUuid);
        } else {
          console.warn('No addresses found for selected shipper.');
        }
      }
    }, error => {
      console.error('Error fetching shipper details:', error);
    });
  }

  onAddressSelected(addressUuid: string) {
    const addr = this.addresses.find(a => a.contact_address_uuid === addressUuid);
    if (addr) {
      this.newShipperInfoForm.patchValue({
        shipper_locality: addr.locality,
        shipper_region: addr.region
      });
    }
  }

  onSubmit(): void {
    if (this.newShipperInfoForm.valid) {
      this.dialogRef.close(this.newShipperInfoForm.value);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}